<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{

    }
  },
  mounted(){
     this.$store.commit('setlang','zh-TCC');
     this.$i18n.locale='zh-TCC';
  }
}
</script>

<style>
/* @import './common/font/font.css'; */

#app {
    font-family: 'Microsoft JhengHei',sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin:0 0;
  padding:0 0;
  min-height: 100%;
 
}
::selection {
    background: #9bd9dd;
    color:#fff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue